import { DropdownOption } from "@ofrz/ui-package";
import { FilterTab } from "components/tab-filter/tab-filter.props";
import { InvoiceProductModel } from "libs/models/invoice";
import { LookupModel } from "libs/models/lookup-model";
import { TransactionsData } from "libs/models/transaction";
import { StringfyDate } from "utils/date";
import translate from "../../utils/translations";

export const productsHeaders = [
  {
    title: translate("Product_Name_Text", "Product Name TODO"),
    dataIndex: "productName",
    key: "productName",
    isSortable: false,
  },
  {
    title: translate("QTY_Text", "QTY TODO"),
    dataIndex: "cardSold",
    key: "cardSold",
    isSortable: false,
  },
  {
    title: translate("Unit_Price_Text", "Unit Price TODO"),
    dataIndex: "unitPrice",
    key: "unitPrice",
    isSortable: false,
  },
  {
    title: translate("Amount_Due_Text", "Amount due TODO"),
    dataIndex: "clickFee",
    key: "clickFee",
    isSortable: false,
  },
];
export const transactionsHeaders = [
  {
    title: translate("Reference_Number_Text", "Reference Number TODO"),
    dataIndex: "referenceNumber",
    key: "referenceNumber",
    isSortable: false,
  },
  {
    title: translate("Product_Name_Text", "Product Name TODO"),
    dataIndex: "productName",
    key: "productName",
    isSortable: false,
  },
  {
    title: translate("Transaction_Date_Text", "Transaction Date TODO"),
    dataIndex: "transactionDate",
    key: "transactionDate",
    isSortable: false,
  },
  {
    title: translate("Transaction_Amount_Text", "Transaction Amount TODO"),
    dataIndex: "transactionAmount",
    key: "transactionAmount",
    isSortable: false,
  },
  {
    title: translate("Margin_Fees_Text", "Margin Fees TODO"),
    dataIndex: "marginFees",
    key: "marginFees",
    isSortable: false,
  },
  {
    title: translate("Clicking_Fees_Text", "Clicking Fees TODO"),
    dataIndex: "clickingFees",
    key: "clickingFees",
    isSortable: false,
  },
];
export const getInvoiceTransactionsList = (
  transactionsData: TransactionsData[],
) => {
  const data = [];
  for (var i = 0; i < transactionsData.length; i++) {
    const request = transactionsData[i];
    const row: Record<string, any> = {
      ...request,
      transactionDate: StringfyDate(request.transactionDate),
      transactionAmount: request.transactionAmount?.toLocaleString(),
    };
    data.push(row);
  }
  return data;
};

export const getInvoiceProductsList = (productsData: InvoiceProductModel[]) => {
  const data = [];
  for (var i = 0; i < productsData.length; i++) {
    const request = productsData[i];
    const row: Record<string, any> = {
      ...request,
      cardSold: request.cardSold?.toLocaleString(),
      amountDue: request.redeemedAmount?.toLocaleString(),
      unitPrice: request.unitPrice?.toLocaleString(),
    };
    data.push(row);
  }
  return data;
};

export const statusLookUpOptions = (statusArray: LookupModel[]) => {
  var statusFilteredArray = statusArray.map((obj, index) => {
    return {
      id: obj.id,
      value: obj.name,
    } as DropdownOption;
  });

  return statusFilteredArray;
};
export const getInvoiceStatusOption = (status: string) => {
  return {
    id: 0,
    value: status,
  } as DropdownOption;
};

export const invoiceDetailsFilterTabs: FilterTab[] = [
  {
    id: 1,
    value: translate("Products_Text", "Products TODO"),
  },
  {
    id: 2,
    value: translate("Transactions_Text", "Transactions TODO"),
  },
];
